import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
} from 'reactstrap';

import AdminReportsDataListItem from './DataListItem';

import { slugify } from '../../../helpers';

import LoadingSmall from '../../LoadingSmall';

const AdminReportsDataList = ({
  data,
  columns,
  dataLoading,
}) => (
  <div className="report-data-list">
    {dataLoading ? (
      <LoadingSmall />
    ) : (
      <Table className="report-list">
        <thead>
          <tr>
            {Object.keys(columns).map(key => (
              <th key={key}>{columns[key]}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <AdminReportsDataListItem
              key={
                item.id ||
                item.uuid ||
                item.file_id ||
                slugify(item.label || '') ||
                slugify(item.period || '')
              }
              columns={columns}
              item={item}
            />
          ))}
        </tbody>
      </Table>
    )}
  </div>
);

AdminReportsDataList.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.object.isRequired,
  dataLoading: PropTypes.bool.isRequired,
};

export default AdminReportsDataList;
